import { useState, useEffect } from 'react';
import { useQuery } from 'react-apollo';
import { pathOr, path } from 'ramda';
import moment from 'moment';

import { GET_PROFILE } from 'components/UserMgmt/UserMgmt.queries';
import { Merchant } from 'hooks/useMerchants';

import GET_MERCHANT from './DatePicker.queries';
import { presetDateRanges, today, getStartOf } from './DatePicker.helpers';

type DateRanges = { from: Date; to: Date };

export type UseThisYearFilterPayload = {
  dateRanges: DateRanges;
  disabled: boolean;
};

export const useThisYearFilter = (
  merchantIdArg?: string,
): UseThisYearFilterPayload => {
  const profilePayload = useQuery(GET_PROFILE);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [dateRanges, setDateRanges] = useState<DateRanges>(
    presetDateRanges.thisYear,
  );

  const merchantId = pathOr(
    merchantIdArg,
    ['data', 'userProfile', 'merchantId'],
    profilePayload,
  );

  const { data } = useQuery(GET_MERCHANT, {
    skip: !merchantId,
    variables: { params: { merchantId } },
  });

  useEffect(() => {
    if (!profilePayload.loading && !merchantId) {
      setDisabled(false);
    }
  }, [profilePayload.loading]);

  useEffect(() => {
    const merchant = path(['merchantList', 'result', 0], data);

    if (merchant) {
      const { firstLiveDate } = merchant as Merchant;
      const startOfYear = moment(getStartOf('year', today));

      if (startOfYear.isBefore(firstLiveDate)) {
        setDateRanges({
          from: !firstLiveDate
            ? startOfYear.toDate()
            : moment(firstLiveDate).toDate(),
          to: today.clone().toDate(),
        });
      }

      setDisabled(false);
    }
  }, [data]);

  return { disabled, dateRanges };
};
